import { LOVE_ORDER_STATUS } from '@/tools/constant'
import loveboxApi from '../apis/lovebox'

const state = {
  loveboxs: {
    currentPage: 0,
    nextPageUrl: 'http://',
    data: [],
    total: 0,
    lastPage: 1,
    loading: false,
    mode: 'col' // 'row' or 'col'
  },
  filterOptions: {
    lovebox: {
      searchType: [],
      sort: '',
      category: ''
    }
  },
  curLovebox: {},
  curLoveCart: {
    box_count: 0,
    items: [],
    ttl: 0
  },
  shopBoxs: {
    curPage: 0,
    nextPageUrl: '//',
    data: []
  },
  loveCollections: {
    curPage: 0,
    nextPageUrl: '//',
    data: []
  },
  loveboxLastestShelveInfo: {
    time: '',
    quantity: 0,
    employees: []
  },
  loveCompanies: {
    data: [],
    currentPage: 0,
    lastPage: 1,
    total: 0,
    isLoading: false
  },
  loveSubscribeCompany: {},
  loveCourseCheckInfo: {
    course: false,
    report: false,
    companyId: 0
  },
  myLoveOrders: {
    data: [],
    currentPage: 0,
    lastPage: 1,
    total: 0,
    isLoading: false
  },
  loveOrderDetail: null,
  batchThankLoveOrder: null,
  thankProvision: null,
  newLoveProvisions: {
    provisions: [
      {
        title: '',
        titleLength: 0,
        imgLists: [],
        quantity: 1,
        isSpread: true,
        isImgLoaded: false,
        desc: ''
      }
    ],
    shipway: 'hct',
    sent_at: '',
    employee_id: '',
    receiver_user_id: '',
    receiver_city: '',
    receiver_district: '',
    receiver_address: '',
    receiver_name: '',
    receiver_phone: '',
    commonweal: null,
    company: null
  },
  thankInfo: {}
}

const actions = {
  getLovebox ({commit, state}, {userRoleType, sort, category, isSearch, page, perPage = 10, cb, isClear = false}) {
    commit('setLoveboxLoading', true)
    return loveboxApi.getLovebox(
      userRoleType,
      sort,
      category,
      page,
      perPage,
      (data) => {
        if (isClear) {
          commit('resetLoveboxs')
        }
        if (data && !data.error) {
          commit('setLoveboxs', {isSearch, data})
        }
        cb && cb(data)
      }
    )
  },
  getLoveboxList ({commit, state}, {userRoleType, isTraceUser, ongoing, sort, category, page, perPage = 10}) {
    commit('setLoveboxLoading', true)
    return loveboxApi.getLoveboxList({
      userRoleType,
      sort,
      category,
      page,
      perPage,
      isTraceUser,
      ongoing
    }).then((data) => {
      commit('setLoveboxs', {data})
    }).catch((err) => {
      commit('setLoveboxLoading', false)
      throw err
    })
  },
  getLoveboxInfo ({commit, state}, {id, cb = null} = {}) {
    loveboxApi.getLoveboxInfo(
      id,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getLoveboxThanks ({commit, state}, {id, cb = null} = {}) {
    loveboxApi.getLoveboxThanks(
      id,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getLoveboxOrderItems ({commit, state}, {id, cb = null} = {}) {
    loveboxApi.getLoveboxOrderItems(
      id,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  addlovboxItem ({commit, state}, {id, quantity, cb = null} = {}) {
    loveboxApi.addlovboxItem(
      id,
      quantity,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getLoveCart ({commit, state}, {cb = null} = {}) {
    loveboxApi.getLoveCart(
      (data) => {
        commit('setCurLoveCart', {data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  updateCount ({commit, state}, {rowId, quantity, cb = null} = {}) {
    loveboxApi.updateCount(
      rowId,
      quantity,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  settleLoveCart ({commit, state}, {consignee, cellphone, address, cb = null} = {}) {
    loveboxApi.settleLoveCart(
      consignee,
      cellphone,
      address,
      (data) => {
        commit('resetCurLoveCart', {data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getMyShopBoxs ({commit, state}, {page, perPage, cb = null} = {}) {
    loveboxApi.getMyShopBoxs(
      page,
      perPage,
      (data) => {
        commit('setMyShopBoxes', {data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getMyLoveOrders ({ commit }, { page, perPage }) {
    return loveboxApi.getMyLoveOrders(page, perPage)
      .then((data) => {
        commit('setMyLoveOrders', data)
      })
  },
  getMyLoveCollections ({commit, state}, {page, cb = null} = {}) {
    loveboxApi.getMyLoveCollections(
      page,
      (data) => {
        commit('setMyLoveCollections', {data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  bookLoveCollections ({commit, state}, {params, cb = null} = {}) {
    loveboxApi.bookLoveCollections(
      params,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  removeItem ({commit, state}, {rowId, cb = null} = {}) {
    loveboxApi.removeItem(
      rowId,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  contactCompany ({commit, state}, {data, cb = null} = {}) {
    loveboxApi.contactCompany(
      data,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  thanksLovebox ({commit, state}, {id, data, cb = null} = {}) {
    loveboxApi.thanks(
      id,
      data,
      (data) => {
        if (cb) {
          cb(data)
        }
      }
    )
  },
  batchLoveOrderThanks ({ commit, state }, { orderId, thanks }) {
    loveboxApi.batchLoveOrderThanks(thanks)
      .then((res) => {
        commit('setLoveOrderThanked', orderId)
        return res.data
      })
  },
  getLoveboxLastestShelveTime ({ commit }) {
    return loveboxApi.getLoveboxLastestShelveTime()
      .then(data => {
        commit('setLastestShelveTime', data)
        return data
      })
  },
  getLoveboxCompanies ({ commit }, { page, perPage }) {
    commit('setLoveboxCompaniesLoading', true)
    return loveboxApi.getLoveboxCompanies(page, perPage)
      .then(data => {
        commit('setLoveboxCompanies', data)
        return data
      })
  },
  publishLoveProvision ({commit, state}, {data}) {
    return loveboxApi.publishLoveProvision(data)
      .then((res) => {
        return res.data
      })
  },
  getLoveOrderWithProvisionId ({commit, state}, {provisionId}) {
    return loveboxApi.getLoveOrderWithProvisionId(provisionId)
      .then((res) => {
        return res.data
      })
  },
  setLoveOrderReceived ({ commit, state }, { orderId }) {
    return loveboxApi.setLoveOrderReceived(orderId)
      .then((res) => {
        commit('setLoveOrderStatus', { orderId, status: LOVE_ORDER_STATUS.STATUS_RECEIVED })
        return res.data
      })
  },
  thankLoveOrder ({commit}, {data}) {
    return loveboxApi.thankLoveOrder(data)
      .then((res) => {
        commit('setLoveOrderStatus', { orderId: data.love_order_id, status: LOVE_ORDER_STATUS.STATUS_DONE })
        return res.data
      })
  }
}

const mutations = {
  setLoveboxLoading (state, loading) {
    state.loveboxs = {
      ...state.loveboxs,
      loading
    }
  },
  setLoveboxs (state, {isSearch, data}) {
    if (data.current_page === 1) {
      state.loveboxs.data = []
    }
    state.loveboxs = {
      ...state.loveboxs,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...state.loveboxs.data,
        ...data.data
      ],
      lastPage: data.last_page,
      total: data.total,
      loading: false
    }
  },
  resetLoveboxs (state) {
    state.loveboxs = {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: [],
      total: 0,
      lastPage: 1,
      loading: false,
      mode: state.loveboxs.mode
    }
  },
  setLoveboxFilterOptions (state, {searchType, sort, category, poolType}) {
    if (poolType === 'lovebox') {
      state.filterOptions = {
        ...state.filterOptions,
        lovebox: {
          type: 'lovebox',
          searchType,
          sort,
          category
        }
      }
    }
  },
  setCurrentLovebox (state, {data}) {
    state.curLovebox = data
  },
  updateCurrentLovebox (state, {data}) {
    state.curLovebox = {
      ...state.curLovebox,
      ...data
    }
  },
  setCurLoveCart (state, {data}) {
    state.curLoveCart = {
      ...state.curLoveCart,
      ...data
    }
  },
  resetCurLoveCart (state) {
    state.curLoveCart = {
      box_count: 0,
      items: [],
      ttl: 0
    }
  },
  setMyShopBoxes (state, {data}) {
    state.shopBoxs = {
      curPage: data.current_page,
      data: data.current_page === 1 ? data.data : [...state.shopBoxs.data, ...data.data],
      nextPageUrl: data.next_page_url
    }
  },
  resetMyShopBoxes (state) {
    state.shopBoxs = {
      curPage: 0,
      nextPageUrl: '//',
      data: []
    }
  },
  setMyLoveCollections (state, {data}) {
    state.loveCollections = {
      curPage: data.current_page,
      data: [...state.loveCollections.data, ...data.data],
      nextPageUrl: data.next_page_url
    }
  },
  addMyLoveCollections (state, {data}) {
    state.loveCollections = {
      ...state.loveCollections,
      data: [data, ...state.loveCollections.data]
    }
  },
  setLastestShelveTime (state, data) {
    state.loveboxLastestShelveInfo = {
      time: data.time,
      quantity: parseInt(data.quantity),
      employees: data.employees
    }
  },
  setLoveboxCompaniesLoading (state, loading) {
    state.loveCompanies = {
      ...state.loveCompanies,
      isLoading: loading
    }
  },
  setLoveboxCompanies (state, data) {
    state.loveCompanies = {
      ...state.loveCompanies,
      data: data.current_page === 1 ? data.data : [...state.loveCompanies.data, ...data.data],
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total,
      isLoading: false
    }
  },
  setLoveSubscribeCompany (state, data) {
    state.loveSubscribeCompany = data
  },
  setLoveCourseCheckInfo (state, data) {
    state.loveCourseCheckInfo = {
      ...state.loveCourseCheckInfo,
      ...data
    }
  },
  changeCurrentViewMode (state, { mode }) {
    state.loveboxs.mode = mode
  },
  setMyLoveOrders (state, data) {
    state.myLoveOrders = {
      ...state.myLoveOrders,
      data: data.current_page === 1 ? data.data : [...state.myLoveOrders.data, ...data.data],
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total,
      isLoading: false
    }
  },
  setLoverOrderItemThanked (state, orderItemId) {
    for (let order of state.myLoveOrders.data) {
      for (let item of order.love_order_items) {
        if (item.id === orderItemId) {
          item.thanked = 1
        }
      }
    }

    state.myLoveOrders.data = [ ...state.myLoveOrders.data ]
  },
  setLoveOrderThanked (state, orderId) {
    for (let order of state.myLoveOrders.data) {
      if (order.id === orderId) {
        for (let item of order.love_order_items) {
          item.thanked = 1
        }
        break
      }
    }
  },
  setThankLoveProvision (state, thankProvision) {
    state.thankProvision = thankProvision
  },
  setLoverOrderPaid (state, { orderId, status }) {
    for (let order of state.myLoveOrders.data) {
      if (order.id === orderId) {
        order.status = status
      }
    }

    state.myLoveOrders.data = [ ...state.myLoveOrders.data ]
  },
  setBatchThankLoveOrder (state, { loveOrder }) {
    state.batchThankLoveOrder = loveOrder
  },
  setNewLoveProvisions (state, payload) {
    state.newLoveProvisions = {
      ...state.newLoveProvisions,
      ...payload
    }
  },
  setNewLoveProvisionsItems (state, { index, item }) {
    let provisions = Object.assign([], state.newLoveProvisions.provisions)
    provisions[index] = {
      ...provisions[index],
      ...item
    }
    state.newLoveProvisions.provisions = provisions
  },
  resetNewLoveProvisions (state) {
    state.newLoveProvisions = {
      ...state.newLoveProvisions,
      provisions: [
        {
          title: '',
          titleLength: 0,
          imgLists: [],
          quantity: 1,
          isSpread: true,
          isImgLoaded: false,
          desc: ''
        }
      ],
      shipway: 'hct',
      employee_id: '',
      receiver_user_id: '',
      receiver_city: '',
      receiver_district: '',
      receiver_address: '',
      receiver_name: '',
      receiver_phone: '',
      company: null,
      commonweal: null
    }
  },
  addNewLoveProvisionsItem (state, type) {
    state.newLoveProvisions.provisions = [
      ...state.newLoveProvisions.provisions,
      {
        title: '',
        titleLength: 0,
        imgLists: [],
        quantity: 1,
        isSpread: true,
        isImgLoaded: false,
        desc: ''
      }
    ]
  },
  removeNewLoveProvisionsItem (state, payload) {
    state.newLoveProvisions.provisions = payload
  },
  setLoveOrderStatus (state, { orderId }) {
    for (let order of state.myLoveOrders.data) {
      if (order.id === orderId) {
        order.status = LOVE_ORDER_STATUS.STATUS_RECEIVED
        break
      }
    }
    state.myLoveOrders.data = [...state.myLoveOrders.data]
  },
  setLoveThankEditInfo (state, { thankInfo }) {
    state.thankInfo = thankInfo
  }
}

export default{
  state,
  actions,
  mutations
}
